import { Skeleton } from "@/components/ui/skeleton";

export const InspirationSkeleton = () => {
  return (
    <main className="flex-1 p-3 md:p-6 pb-16 flex justify-center overflow-y-auto">
      <div className="w-full max-w-[1200px] space-y-4 md:space-y-6 pb-16" role="status" aria-label="Ładowanie inspiracji">
        {/* Next scraping progress */}
        <Skeleton className="h-12 w-full rounded-xl" />

        {/* Add source card */}
        <div className="rounded-2xl border border-border/50 p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12">
            {/* Globe placeholder */}
            <Skeleton className="w-[120px] h-[120px] rounded-full self-center md:self-start flex-shrink-0" />

            {/* Input area */}
            <div className="flex-1 w-full space-y-3">
              <Skeleton className="h-10 w-full max-w-md rounded-lg" />
              <Skeleton className="h-3 w-48" />
            </div>
          </div>
        </div>

        {/* Sources list header */}
        <Skeleton className="h-6 w-56" />

        {/* Source cards */}
        <div className="grid gap-3 md:gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="rounded-2xl border border-border/50 p-4 md:p-6">
              <div className="flex items-center gap-4">
                <Skeleton className="h-12 w-12 rounded-xl flex-shrink-0" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-48" />
                </div>
                <Skeleton className="h-8 w-8 rounded-lg" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};
